// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"407":"1e7cf6c3","440":"f61d014b","654":"d6980f86","678":"78bef619","691":"78bef619","828":"f61d014b","879":"d6980f86","900":"f61d014b","966":"5bac36a5"}[chunkId] + ".chunk.css";
};